/* eslint-disable no-multi-assign */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { fabric } from 'fabric';
import { getViewportTransform, isEdgeOfPage, FABRIC_CUSTOM_OBJECT } from '..';

const aligningLineOffset = 5;
const aligningLineMargin = 4;
const aligningLineWidth = 1;
const aligningLineColor = '#3333ff';
const EPS = 0.5;
const MORE_EPS = 8;
const EPS_SCALING = 8;
const EPS_DISTANCE = 2;
let viewportTransform;
const distanceLines = [];
const distanceLinesConnectObj = [];
let CORNER = null;
let TARGET_CORNER = null;
function drawLine(x2, y2, x1, y1) {
  const ctx = window.canvas.getSelectionContext();
  const { translationX, translationY, scaleX, scaleY } = getViewportTransform();
  ctx.save();
  ctx.lineWidth = aligningLineWidth;
  ctx.strokeStyle = aligningLineColor;
  ctx.beginPath();
  ctx.moveTo(x1 * scaleX + translationX, y1 * scaleY + translationY);
  ctx.lineTo(x2 * scaleX + translationX, y2 * scaleY + translationY);
  ctx.stroke();
  ctx.restore();
}
function drawDistanceLine(x2, y2, x1, y1) {
  const ctx = window.canvas.getSelectionContext();
  const { translationX, translationY, scaleX, scaleY } = getViewportTransform();
  ctx.save();
  ctx.lineWidth = aligningLineWidth + 1;
  // ctx.strokeStyle = aligningLineColor;
  ctx.strokeStyle = 'red';
  ctx.fillStyle = 'red';
  ctx.beginPath();
  if (x1 === x2) {
    ctx.moveTo((x1 + 1) * scaleX + translationX, y1 * scaleY + translationY);
    ctx.lineTo((x2 + 1) * scaleX + translationX, y2 * scaleY + translationY);
  } else {
    ctx.moveTo(x1 * scaleX + translationX, (y1 + 1) * scaleY + translationY);
    ctx.lineTo(x2 * scaleX + translationX, (y2 + 1) * scaleY + translationY);
  }
  ctx.stroke();
  const str = String(Math.round(Math.abs(x1 - x2 + y1 - y2)));
  ctx.font = '13px Arial';

  if (x1 === x2) {
    ctx.fillText(str, ((x1 + x2 + 5) / 2) * scaleX + translationX, ((y1 + y2 + 6.5) / 2) * scaleY + translationY);
  } else {
    ctx.textAlign = 'center';
    ctx.fillText(str, ((x1 + x2) / 2) * scaleX + translationX, ((y1 + y2 - 13) / 2) * scaleY + translationY);
  }
  ctx.restore();
}
// str = "top" "bot" "left" "right"
function drawDistanceLineFromObj(x2, y2, x1, y1) {
  const ctx = window.canvas.getSelectionContext();
  const { translationX, translationY, scaleX, scaleY } = getViewportTransform();
  ctx.save();
  ctx.lineWidth = aligningLineWidth + 1;
  ctx.strokeStyle = '#d420bf';
  ctx.fillStyle = '#d420bf';
  ctx.beginPath();
  if (x1 === x2) {
    ctx.moveTo((x1 + 1) * scaleX + translationX, y1 * scaleY + translationY);
    ctx.lineTo((x2 + 1) * scaleX + translationX, y2 * scaleY + translationY);
  } else {
    ctx.moveTo(x1 * scaleX + translationX, (y1 + 1) * scaleY + translationY);
    ctx.lineTo(x2 * scaleX + translationX, (y2 + 1) * scaleY + translationY);
  }
  ctx.stroke();
  const str = String(Math.round(Math.abs(x1 - x2 + y1 - y2)));
  ctx.font = '13px Arial';

  if (x1 === x2) {
    ctx.fillText(str, ((x1 + x2 + 5) / 2) * scaleX + translationX, ((y1 + y2 + 6.5) / 2) * scaleY + translationY);
  } else {
    ctx.textAlign = 'center';
    ctx.fillText(str, ((x1 + x2) / 2) * scaleX + translationX, ((y1 + y2 - 13) / 2) * scaleY + translationY);
  }
  ctx.restore();
}
function checkObj(obj) {
  if (obj?.type === 'polyline' || obj?.isNotObj || (obj?.name === 'Label' && obj?.polylineId))
    if (
      obj?.type === FABRIC_CUSTOM_OBJECT.polyline ||
      obj?.isNotObj ||
      (obj?.name === FABRIC_CUSTOM_OBJECT.label && obj?.polylineId) ||
      isEdgeOfPage(obj)
    )
      return false;
  return true;
}
function addVerDistanceLine(Top, Bot, str) {
  let X;
  if (str === 'left') {
    X = Math.min(Math.max(Top.left, Bot.left), Math.min(Top.right, Bot.right));
  }
  if (str === 'right') {
    X = Math.max(Math.max(Top.left, Bot.left), Math.min(Top.right, Bot.right));
  }
  distanceLinesConnectObj.push({
    x1: X,
    y1: Top.bottom,
    x2: X,
    y2: Bot.top,
    distance: Math.round(Math.abs(Top.bottom - Bot.top)),
  });
}
function addHozDistanceLine(Left, Right, str) {
  let Y;
  if (str === 'top') {
    Y = Math.min(Math.max(Left.top, Right.top), Math.min(Left.bottom, Right.bottom));
  }
  if (str === 'bot') {
    Y = Math.max(Math.max(Left.top, Right.top), Math.min(Left.bottom, Right.bottom));
  }
  distanceLinesConnectObj.push({
    x1: Left.right,
    y1: Y,
    x2: Right.left,
    y2: Y,
    distance: Math.round(Math.abs(Left.right - Right.left)),
  });
}
function drawTopBot(Top, Bot, arr) {
  const xCenter = (Math.max(Top.left, Bot.left) + Math.min(Top.right, Bot.right)) / 2;
  arr.push({
    x1: xCenter,
    y1: Top.bottom,
    x2: xCenter,
    y2: Bot.top,
    distance: Math.round(Math.abs(Top.bottom - Bot.top)),
  });
}
function drawLeftRight(Left, Right, arr) {
  const yCenter = (Math.max(Left.top, Right.top) + Math.min(Left.bottom, Right.bottom)) / 2;
  arr.push({
    x1: Left.right,
    y1: yCenter,
    x2: Right.left,
    y2: yCenter,
    distance: Math.round(Math.abs(Left.right - Right.left)),
  });
}
function intersectX(A, B) {
  if (CORNER) {
    A.left -= 1.5;
    A.right += 1.5;
    A.bottom += 1.5;
    A.top -= 1.5;
  }
  return (
    (B.left <= A.left && A.left <= B.right) ||
    (B.left <= A.right && A.right <= B.right) ||
    (A.left <= B.left && B.left <= A.right) ||
    (A.left <= B.right && B.right <= A.right)
  );
}
function intersectY(A, B) {
  if (CORNER) {
    A.left -= 1.5;
    A.right += 1.5;
    A.bottom += 1.5;
    A.top -= 1.5;
  }
  return (
    (B.top <= A.top && A.top <= B.bottom) ||
    (B.top <= A.bottom && A.bottom <= B.bottom) ||
    (A.top <= B.top && B.top <= A.bottom) ||
    (A.top <= B.bottom && B.bottom <= A.bottom)
  );
}
function getCoord(obj) {
  if (obj.scaleX !== 1 || obj.scaleY !== 1) {
    return {
      top: obj.top,
      bottom: obj.top + obj.getScaledHeight(),
      left: obj.left,
      right: obj.left + obj.getScaledWidth(),
    };
  }
  return {
    top: obj.top,
    bottom: obj.top + obj.height,
    left: obj.left,
    right: obj.left + obj.width,
  };
}
// obj, distance, stop:true/false, str: "up" "down" "left" "right", moreEps: MORE_EPS / 0
function findObj(obj, distance, stop, str, arr, mEps) {
  if (distance <= 0) return;
  const { canvas } = window;
  const A = getCoord(obj);
  let newDistance = distance;
  let moreEps = mEps;
  canvas.getObjects().map((e) => {
    const B = getCoord(e);
    if (checkObj(e)) {
      switch (str) {
        case 'up':
          if (Math.abs(newDistance - (A.top - B.bottom)) <= EPS + moreEps && intersectX(A, B)) {
            moreEps = 0;
            drawTopBot(B, A, arr);
            if (mEps) newDistance = A.top - B.bottom;
            if (!stop) findObj(e, newDistance, stop, str, arr, 0);
          }
          break;
        case 'down':
          if (Math.abs(newDistance - (B.top - A.bottom)) <= EPS + moreEps && intersectX(A, B)) {
            moreEps = 0;
            drawTopBot(A, B, arr);
            if (mEps) newDistance = B.top - A.bottom;
            if (!stop) findObj(e, newDistance, stop, str, arr, 0);
          }
          break;
        case 'left':
          if (Math.abs(newDistance - (A.left - B.right)) <= EPS + moreEps && intersectY(A, B)) {
            moreEps = 0;
            drawLeftRight(B, A, arr);
            if (mEps) newDistance = A.left - B.right;
            if (!stop) findObj(e, newDistance, stop, str, arr, 0);
          }
          break;
        case 'right':
          if (Math.abs(newDistance - (B.left - A.right)) <= EPS + moreEps && intersectY(A, B)) {
            moreEps = 0;
            drawLeftRight(A, B, arr);
            if (mEps) newDistance = B.left - A.right;
            if (!stop) findObj(e, newDistance, stop, str, arr, 0);
          }
          break;
        default:
          break;
      }
    }
    return e;
  });
}
function setAlignmentDistance(obj) {
  const { canvas } = window;
  obj.setCoords();
  let A = getCoord(obj);
  let UP = null;
  let DOWN = null;
  let LEFT = null;
  let RIGHT = null;
  let deltaX = 0;
  let deltaY = 0;
  let sumDelta = 0;
  canvas.getObjects().map((e) => {
    if (checkObj(e) && e !== obj) {
      const B = getCoord(e);
      if (intersectX(A, B) && A.top > B.bottom && sumDelta < 1) {
        const arr = [];
        findObj(e, Math.round(A.top - B.bottom), false, 'up', arr, MORE_EPS);
        if (arr.length >= 1) {
          const { distance } = arr[arr.length - 1];
          deltaY = A.top - B.bottom - distance;
          sumDelta += Math.abs(deltaY);
          obj.set({
            top: obj.top - deltaY,
          });
          obj.setCoords();
          A = getCoord(obj);
          drawTopBot(B, A, arr);
          if (!UP || UP[0].distance >= arr[0].distance) UP = [...arr];
        }
      }

      if (intersectX(A, B) && B.top > A.bottom && sumDelta < 1) {
        const arr = [];
        findObj(e, Math.round(B.top - A.bottom), false, 'down', arr, MORE_EPS);
        if (arr.length >= 1) {
          const { distance } = arr[arr.length - 1];
          deltaY = B.top - A.bottom - distance;
          sumDelta += Math.abs(deltaY);
          obj.set({
            top: obj.top + deltaY,
          });
          obj.setCoords();
          A = getCoord(obj);
          drawTopBot(A, B, arr);
          if (!DOWN || DOWN[0].distance >= arr[0].distance) DOWN = [...arr];
        }
      }

      if (intersectY(A, B) && B.left > A.right && sumDelta < 1) {
        const arr = [];
        findObj(e, Math.round(B.left - A.right), false, 'right', arr, MORE_EPS);
        if (arr.length >= 1) {
          const { distance } = arr[arr.length - 1];
          deltaX = B.left - A.right - distance;
          // if (!sumDelta && (sumDelta + Math.abs(deltaX) > 1)) return e;
          sumDelta += Math.abs(deltaX);
          obj.set({
            left: obj.left + deltaX,
          });
          obj.setCoords();
          A = getCoord(obj);
          drawLeftRight(A, B, arr);
          if (!RIGHT || RIGHT[0].distance >= arr[0].distance) RIGHT = [...arr];
        }
      }

      if (intersectY(A, B) && A.left > B.right && sumDelta < 1) {
        const arr = [];
        findObj(e, Math.round(A.left - B.right), false, 'left', arr, MORE_EPS);
        if (arr.length >= 1) {
          const { distance } = arr[arr.length - 1];
          deltaX = A.left - B.right - distance;
          sumDelta += Math.abs(deltaX);
          obj.set({
            left: obj.left - deltaX,
          });
          obj.setCoords();
          A = getCoord(obj);
          drawLeftRight(B, A, arr);
          if (!LEFT || LEFT[0].distance >= arr[0].distance) LEFT = [...arr];
        }
      }
    }
    return e;
  });
  if (UP) distanceLines.push(...UP);
  if (DOWN) distanceLines.push(...DOWN);
  if (LEFT) distanceLines.push(...LEFT);
  if (RIGHT) distanceLines.push(...RIGHT);
}

function setAlignmentWhenScaling(obj, corner) {
  function minAbs(...values) {
    const absValues = values.map((e) => Math.abs(e));
    const minValues = Math.min(...absValues);
    let res = values[0];
    values.map((e) => {
      if (Math.abs(e) === minValues) res = e;
      return e;
    });
    return res;
  }
  const { canvas } = window;
  obj.setCoords();
  const A = getCoord(obj);

  let deltaLeft = 1000;
  let deltaRight = 1000;
  let deltaTop = 1000;
  let deltaBot = 1000;

  canvas.getObjects().map((e) => {
    if (checkObj(e) && e !== obj) {
      const B = getCoord(e);
      deltaLeft = minAbs(deltaLeft, A.left - B.left, A.left - B.right);
      deltaRight = minAbs(deltaRight, A.right - B.left, A.right - B.right);
      deltaTop = minAbs(deltaTop, A.top - B.bottom, A.top - B.top);
      deltaBot = minAbs(deltaBot, A.bottom - B.bottom, A.bottom - B.top);
    }
    return e;
  });
  const oldXY = getCoord(obj);
  let percentage;
  if (obj.scaleX === obj.scaleY && obj.scaleX === 1) {
    switch (corner) {
      case 'ml':
        if (Math.abs(deltaLeft) > EPS_SCALING) break;
        obj.set({
          left: obj.left - deltaLeft,
          width: obj.width + deltaLeft,
        });
        obj.setCoords();
        break;

      case 'mr':
        if (Math.abs(deltaRight) > EPS_SCALING) break;
        obj.set({ width: obj.width - deltaRight });
        obj.setCoords();
        break;

      case 'mt':
        if (Math.abs(deltaTop) > EPS_SCALING) break;
        obj.set({
          top: obj.top - deltaTop,
          height: obj.height + deltaTop,
        });
        obj.setCoords();
        break;

      case 'mb':
        if (Math.abs(deltaBot) > EPS_SCALING) break;
        obj.set({ height: obj.height - deltaBot });
        obj.setCoords();
        break;

      case 'tl':
        if (Math.abs(deltaLeft) > EPS_SCALING && Math.abs(deltaTop) > EPS_SCALING) break;
        if (Math.abs(deltaLeft) < Math.abs(deltaTop)) {
          percentage = -deltaLeft / obj.width;
        } else {
          percentage = -deltaTop / obj.height;
        }
        obj.set({
          width: obj.width * (1 - percentage),
          height: obj.height * (1 - percentage),
          top: oldXY.bottom - obj.height * (1 - percentage),
          left: oldXY.right - obj.width * (1 - percentage),
        });
        obj.setCoords();
        break;
      case 'tr':
        if (Math.abs(deltaRight) > EPS_SCALING && Math.abs(deltaTop) > EPS_SCALING) break;
        if (Math.abs(deltaRight) < Math.abs(deltaTop)) {
          percentage = deltaRight / obj.width;
        } else {
          percentage = -deltaTop / obj.height;
        }
        obj.set({
          width: obj.width * (1 - percentage),
          height: obj.height * (1 - percentage),
          top: oldXY.bottom - obj.height * (1 - percentage),
        });
        obj.setCoords();
        break;
      case 'bl':
        if (Math.abs(deltaLeft) > EPS_SCALING && Math.abs(deltaBot) > EPS_SCALING) break;
        if (Math.abs(deltaLeft) < Math.abs(deltaBot)) {
          percentage = -deltaLeft / obj.width;
        } else {
          percentage = deltaBot / obj.height;
        }
        obj.set({
          width: obj.width * (1 - percentage),
          height: obj.height * (1 - percentage),
          left: oldXY.right - obj.width * (1 - percentage),
        });
        obj.setCoords();
        break;
      case 'br':
        if (Math.abs(deltaRight) > EPS_SCALING && Math.abs(deltaBot) > EPS_SCALING) break;
        if (Math.abs(deltaRight) < Math.abs(deltaBot)) {
          percentage = deltaRight / obj.width;
        } else {
          percentage = deltaBot / obj.height;
        }
        obj.set({
          width: obj.width * (1 - percentage),
          height: obj.height * (1 - percentage),
        });
        obj.setCoords();
        break;
      default:
        break;
    }
  } else {
    switch (corner) {
      case 'ml':
        if (Math.abs(deltaLeft) > EPS_SCALING) break;
        obj.set({ scaleX: (obj.getScaledWidth() + deltaLeft) / obj.width });
        obj.set({
          left: A.right - obj.getScaledWidth(),
        });
        obj.setCoords();
        break;
      case 'mr':
        if (Math.abs(deltaRight) > EPS_SCALING) break;
        obj.set({ scaleX: (obj.getScaledWidth() - deltaRight) / obj.width });
        obj.setCoords();
        break;
      case 'mt':
        if (Math.abs(deltaTop) > EPS_SCALING) break;
        obj.set({
          scaleY: obj.scaleY + (1.0 * deltaTop) / (1.0 * obj.height),
        });
        obj.set({
          top: A.bottom - obj.getScaledHeight(),
        });
        obj.setCoords();
        break;
      case 'mb':
        if (Math.abs(deltaBot) > EPS_SCALING) break;
        obj.set({ scaleY: (obj.getScaledHeight() - deltaBot) / obj.height });
        obj.setCoords();
        break;
      case 'tl':
        if (Math.abs(deltaLeft) > EPS_SCALING && Math.abs(deltaTop) > EPS_SCALING) break;
        if (Math.abs(deltaLeft) < Math.abs(deltaTop)) {
          percentage = -deltaLeft / obj.width;
        } else {
          percentage = -deltaTop / obj.height;
        }
        obj.set({
          scaleX: obj.scaleX - percentage,
          scaleY: obj.scaleY - percentage,
        });
        obj.set({
          top: A.bottom - obj.getScaledHeight(),
          left: A.right - obj.getScaledWidth(),
        });
        obj.setCoords();
        break;
      case 'tr':
        if (Math.abs(deltaRight) > EPS_SCALING && Math.abs(deltaTop) > EPS_SCALING) break;
        if (Math.abs(deltaRight) < Math.abs(deltaTop)) {
          percentage = deltaRight / obj.width;
        } else {
          percentage = -deltaTop / obj.height;
        }
        obj.set({
          scaleX: obj.scaleX - percentage,
          scaleY: obj.scaleY - percentage,
        });
        obj.set({
          top: oldXY.bottom - obj.getScaledHeight(),
        });
        obj.setCoords();
        break;
      case 'bl':
        if (Math.abs(deltaLeft) > EPS_SCALING && Math.abs(deltaBot) > EPS_SCALING) break;
        if (Math.abs(deltaLeft) < Math.abs(deltaBot)) {
          percentage = -deltaLeft / obj.width;
        } else {
          percentage = deltaBot / obj.height;
        }
        obj.set({
          scaleX: obj.scaleX - percentage,
          scaleY: obj.scaleY - percentage,
        });
        obj.set({
          left: A.right - obj.getScaledWidth(),
        });
        obj.setCoords();
        break;
      case 'br':
        if (Math.abs(deltaRight) > EPS_SCALING && Math.abs(deltaBot) > EPS_SCALING) break;
        if (Math.abs(deltaRight) < Math.abs(deltaBot)) {
          percentage = deltaRight / obj.width;
        } else {
          percentage = deltaBot / obj.height;
        }
        obj.set({
          scaleX: obj.scaleX - percentage,
          scaleY: obj.scaleY - percentage,
        });
        obj.setCoords();
        break;
      default:
        break;
    }
  }
}
function locatingObject(obj) {
  const { canvas } = window;
  obj.setCoords();
  const A = getCoord(obj);

  let top1 = null;
  let bot1 = null;
  let left1 = null;
  let right1 = null;
  let top2 = null;
  let bot2 = null;
  let left2 = null;
  let right2 = null;

  // left: A.left, right: A.right, bottom: A.bottom, top: A.top,
  canvas.getObjects().map((e) => {
    // top
    if (checkObj(e) && e !== obj) {
      e.setCoords();
      const B = getCoord(e);
      if (
        intersectX(
          {
            left: A.left,
            right: A.left,
            bottom: A.bottom,
            top: A.top,
          },
          B,
        ) &&
        A.top - B.bottom > 0 &&
        Math.min(Math.abs(A.left - B.left), Math.abs(A.left - B.right)) < EPS_DISTANCE
      ) {
        if (!top1 || top1.distance > A.top - B.bottom) {
          top1 = { obj: B, distance: A.top - B.bottom };
        }
      }
      if (
        intersectX(
          {
            left: A.right,
            right: A.right,
            bottom: A.bottom,
            top: A.top,
          },
          B,
        ) &&
        A.top - B.bottom > 0 &&
        Math.min(Math.abs(A.right - B.left), Math.abs(A.right - B.right)) < EPS_DISTANCE
      ) {
        if (!top2 || top2.distance > A.top - B.bottom) {
          top2 = { obj: B, distance: A.top - B.bottom };
        }
      }
      // bot
      if (
        intersectX(
          {
            left: A.left,
            right: A.left,
            bottom: A.bottom,
            top: A.top,
          },
          B,
        ) &&
        B.top - A.bottom > 0 &&
        Math.min(Math.abs(A.left - B.left), Math.abs(A.left - B.right)) < EPS_DISTANCE
      ) {
        if (!bot1 || bot1.distance > B.top - A.bottom) {
          bot1 = { obj: B, distance: B.top - A.bottom };
        }
      }
      if (
        intersectX(
          {
            left: A.right,
            right: A.right,
            bottom: A.bottom,
            top: A.top,
          },
          B,
        ) &&
        B.top - A.bottom > 0 &&
        Math.min(Math.abs(A.right - B.left), Math.abs(A.right - B.right)) < EPS_DISTANCE
      ) {
        if (!bot2 || bot2.distance > B.top - A.bottom) {
          bot2 = { obj: B, distance: B.top - A.bottom };
        }
      }
      // left
      if (
        intersectY(
          {
            left: A.left,
            right: A.right,
            bottom: A.top,
            top: A.top,
          },
          B,
        ) &&
        A.left - B.right > 0 &&
        Math.min(Math.abs(A.top - B.top), Math.abs(A.top - B.bottom)) < EPS_DISTANCE
      ) {
        if (!left1 || left1.distance > A.left - B.right) {
          left1 = { obj: B, distance: A.left - B.right };
        }
      }
      if (
        intersectY(
          {
            left: A.left,
            right: A.right,
            bottom: A.bottom,
            top: A.bottom,
          },
          B,
        ) &&
        A.left - B.right > 0 &&
        Math.min(Math.abs(A.bottom - B.top), Math.abs(A.bottom - B.bottom)) < EPS_DISTANCE
      ) {
        if (!left2 || left2.distance > A.left - B.right) {
          left2 = { obj: B, distance: A.left - B.right };
        }
      }
      // right
      if (
        intersectY(
          {
            left: A.left,
            right: A.right,
            bottom: A.top,
            top: A.top,
          },
          B,
        ) &&
        B.left - A.right > 0 &&
        Math.min(Math.abs(A.top - B.top), Math.abs(A.top - B.bottom)) < EPS_DISTANCE
      ) {
        if (!right1 || right1.distance > B.left - A.right) {
          right1 = { obj: B, distance: B.left - A.right };
        }
      }
      if (
        intersectY(
          {
            left: A.left,
            right: A.right,
            bottom: A.bottom,
            top: A.bottom,
          },
          B,
        ) &&
        B.left - A.right > 0 &&
        Math.min(Math.abs(A.bottom - B.top), Math.abs(A.bottom - B.bottom)) < EPS_DISTANCE
      ) {
        if (!right2 || right2.distance > B.left - A.right) {
          right2 = { obj: B, distance: B.left - A.right };
        }
      }
    }
    return e;
  });
  if (top1 && top2 && top1.obj === top2.obj) top1 = null;
  if (bot1 && bot2 && bot1.obj === bot2.obj) bot1 = null;
  if (left1 && left2 && left1.obj === left2.obj) left2 = null;
  if (right1 && right2 && right1.obj === right2.obj) right2 = null;

  if (top1) addVerDistanceLine(top1.obj, A, 'left');
  if (top2) addVerDistanceLine(top2.obj, A, 'right');
  if (bot1) addVerDistanceLine(A, bot1.obj, 'left');
  if (bot2) addVerDistanceLine(A, bot2.obj, 'right');
  if (left1) addHozDistanceLine(left1.obj, A, 'top');
  if (left2) addHozDistanceLine(left2.obj, A, 'bot');
  if (right1) addHozDistanceLine(A, right1.obj, 'top');
  if (right2) addHozDistanceLine(A, right2.obj, 'bot');
}

export const initAligningGuidelines = ({ canvas }) => {
  let deltaHorizontal = 1000;
  let deltaVertical = 1000;
  let delta = 1000;

  function drawVerticalLine(coords) {
    drawLine(
      coords.x + 0.5,
      coords.y1 > coords.y2 ? coords.y2 : coords.y1,
      coords.x + 0.5,
      coords.y2 > coords.y1 ? coords.y2 : coords.y1,
    );
  }

  function drawHorizontalLine(coords) {
    drawLine(
      coords.x1 > coords.x2 ? coords.x2 : coords.x1,
      coords.y + 0.5,
      coords.x2 > coords.x1 ? coords.x2 : coords.x1,
      coords.y + 0.5,
    );
  }

  function isInRange(value1, value2) {
    if (Math.abs(value1 - value2) <= aligningLineMargin) {
      delta = Math.round(Math.abs(value1 - value2) * 10000) / 10000;
      return true;
    }
    return false;
  }

  function contained(objA, objB) {
    const A = getCoord(objA);
    const B = getCoord(objB);

    if (
      B.left <= A.left &&
      A.left <= B.right &&
      B.top <= A.top &&
      A.top <= B.bottom &&
      B.left <= A.right &&
      A.right <= B.right &&
      B.top <= A.bottom &&
      A.bottom <= B.bottom
    )
      return true;
    return false;
  }

  const verticalLines = [];
  const horizontalLines = [];

  const setAlignment = (e) => {
    const activeObject = e.target;
    if (activeObject.name === FABRIC_CUSTOM_OBJECT.pathArrow || activeObject.isNotObj) return;
    const canvasObjects = [];
    canvas.getObjects().map((obj) => {
      if (
        obj.name !== FABRIC_CUSTOM_OBJECT.label &&
        !obj.isNotObj &&
        obj.type !== FABRIC_CUSTOM_OBJECT.polyline &&
        !contained(e.target, obj) &&
        !contained(obj, e.target)
      )
        canvasObjects.push(obj);
      return obj;
    });
    const activeObjectCenter = activeObject.getCenterPoint();
    const activeObjectLeft = activeObjectCenter.x;
    const activeObjectTop = activeObjectCenter.y;
    const activeObjectBoundingRect = activeObject.getBoundingRect();
    const activeObjectHeight = activeObjectBoundingRect.height / viewportTransform[3];
    const activeObjectWidth = activeObjectBoundingRect.width / viewportTransform[0];
    let horizontalInTheRange = false;
    let verticalInTheRange = false;
    deltaHorizontal = 1000;
    deltaVertical = 1000;
    verticalLines.length = 0;
    horizontalLines.length = 0;

    const transform = canvas._currentTransform;

    if (!transform) return;

    // It should be trivial to DRY this up by encapsulating (repeating) creation of x1, x2, y1, and y2 into functions,
    // but we're not doing it here for perf. reasons -- as this a function that's invoked on every mouse move
    let oldDeltaHorizontal = 1000;
    let oldDeltaVertical = 1000;
    for (let i = canvasObjects.length; i--; ) {
      oldDeltaHorizontal = deltaHorizontal;
      oldDeltaVertical = deltaVertical;
      // eslint-disable-next-line no-continue
      if (canvasObjects[i] === activeObject) continue;

      const objectCenter = canvasObjects[i].getCenterPoint();
      const objectLeft = objectCenter.x;
      const objectTop = objectCenter.y;
      const objectBoundingRect = canvasObjects[i].getBoundingRect();
      const objectHeight = objectBoundingRect.height / viewportTransform[3];
      const objectWidth = objectBoundingRect.width / viewportTransform[0];

      // snap by the horizontal center line
      if (isInRange(objectLeft, activeObjectLeft) && delta <= deltaVertical) {
        verticalInTheRange = true;
        if (delta < deltaVertical) {
          verticalLines.length = 0;
          deltaVertical = delta;
        }
        if (delta <= deltaVertical && (delta !== deltaVertical || delta < oldDeltaVertical)) {
          verticalLines.push({
            x: objectLeft,
            y1: objectTop,
            y2: activeObjectTop,
            setX: objectLeft,
            setY: activeObjectTop,
            delta,
          });
        }
      }

      // snap by the left edge
      if (isInRange(objectLeft - objectWidth / 2, activeObjectLeft - activeObjectWidth / 2)) {
        verticalInTheRange = true;
        if (delta < deltaVertical) {
          verticalLines.length = 0;
          deltaVertical = delta;
        }

        if (delta <= deltaVertical && (delta !== deltaVertical || delta < oldDeltaVertical)) {
          verticalLines.push({
            x: objectLeft - objectWidth / 2,
            y1:
              objectTop < activeObjectTop
                ? objectTop - objectHeight / 2 - aligningLineOffset
                : objectTop + objectHeight / 2 + aligningLineOffset,
            y2:
              activeObjectTop > objectTop
                ? activeObjectTop + activeObjectHeight / 2 + aligningLineOffset
                : activeObjectTop - activeObjectHeight / 2 - aligningLineOffset,
            setX: objectLeft - objectWidth / 2 + activeObjectWidth / 2,
            setY: activeObjectTop,
            delta,
          });
        }
      }

      // snap by the right edge
      if (isInRange(objectLeft + objectWidth / 2, activeObjectLeft + activeObjectWidth / 2)) {
        verticalInTheRange = true;
        if (delta < deltaVertical) {
          verticalLines.length = 0;
          deltaVertical = delta;
        }
        if (delta <= deltaVertical && (delta !== deltaVertical || delta < oldDeltaVertical)) {
          verticalLines.push({
            x: objectLeft + objectWidth / 2,
            y1:
              objectTop < activeObjectTop
                ? objectTop - objectHeight / 2 - aligningLineOffset
                : objectTop + objectHeight / 2 + aligningLineOffset,
            y2:
              activeObjectTop > objectTop
                ? activeObjectTop + activeObjectHeight / 2 + aligningLineOffset
                : activeObjectTop - activeObjectHeight / 2 - aligningLineOffset,
            setX: objectLeft + objectWidth / 2 - activeObjectWidth / 2,
            setY: activeObjectTop,
            delta,
          });
        }
      }

      // snap by the vertical center line
      if (isInRange(objectTop, activeObjectTop)) {
        horizontalInTheRange = true;
        if (delta < deltaHorizontal) {
          horizontalLines.length = 0;
          deltaHorizontal = delta;
        }
        if (delta <= deltaHorizontal && (delta !== deltaHorizontal || delta < oldDeltaHorizontal)) {
          horizontalLines.push({
            y: objectTop,
            x1: objectLeft,
            x2: activeObjectLeft,
            setX: activeObjectLeft,
            setY: objectTop,
            delta,
          });
        }
      }

      // snap by the top edge
      if (isInRange(objectTop - objectHeight / 2, activeObjectTop - activeObjectHeight / 2)) {
        horizontalInTheRange = true;
        if (delta < deltaHorizontal) {
          horizontalLines.length = 0;
          deltaHorizontal = delta;
        }
        if (delta <= deltaHorizontal && (delta !== deltaHorizontal || delta < oldDeltaHorizontal)) {
          horizontalLines.push({
            y: objectTop - objectHeight / 2,
            x1:
              objectLeft < activeObjectLeft
                ? objectLeft - objectWidth / 2 - aligningLineOffset
                : objectLeft + objectWidth / 2 + aligningLineOffset,
            x2:
              activeObjectLeft > objectLeft
                ? activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset
                : activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset,
            setX: activeObjectLeft,
            setY: objectTop - objectHeight / 2 + activeObjectHeight / 2,
            delta,
          });
        }
      }

      // snap by the bottom edge
      if (isInRange(objectTop + objectHeight / 2, activeObjectTop + activeObjectHeight / 2)) {
        horizontalInTheRange = true;
        if (delta < deltaHorizontal) {
          horizontalLines.length = 0;
          deltaHorizontal = delta;
        }
        if (delta <= deltaHorizontal && (delta !== deltaHorizontal || delta < oldDeltaHorizontal)) {
          horizontalLines.push({
            y: objectTop + objectHeight / 2,
            x1:
              objectLeft < activeObjectLeft
                ? objectLeft - objectWidth / 2 - aligningLineOffset
                : objectLeft + objectWidth / 2 + aligningLineOffset,
            x2:
              activeObjectLeft > objectLeft
                ? activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset
                : activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset,
            setX: activeObjectLeft,
            setY: objectTop + objectHeight / 2 - activeObjectHeight / 2,
            delta,
          });
        }
      }
    }
    if (!horizontalInTheRange) {
      horizontalLines.length = 0;
    }

    if (!verticalInTheRange) {
      verticalLines.length = 0;
    }
    if (horizontalLines.length > 0) {
      activeObject.setPositionByOrigin(
        new fabric.Point(activeObject.getCenterPoint().x, horizontalLines[0].setY),
        'center',
        'center',
      );
    }
    if (verticalLines.length > 0) {
      activeObject.setPositionByOrigin(
        new fabric.Point(verticalLines[0].setX, activeObject.getCenterPoint().y),
        'center',
        'center',
      );
    }
  };

  canvas.on('mouse:down', () => {
    viewportTransform = canvas.viewportTransform || [1, 0, 0, 1, 0, 0];
  });

  canvas.on('object:moving', (e) => {
    if (e?.target?.isNotObj || isEdgeOfPage(e.target)) return;
    setAlignment(e);
    setAlignmentDistance(e.target);
    locatingObject(e.target);
  });

  canvas.on('object:scaling', (e) => {
    // setAlignment(e);
    if (e.target && e.target.isNotObj) return;
    CORNER = e.transform.corner;
    TARGET_CORNER = e.target;
  });

  canvas.on('before:render', () => {
    if (canvas.contextTop) {
      canvas.clearContext(canvas.contextTop);
    }
    if (TARGET_CORNER && CORNER) {
      setAlignmentWhenScaling(TARGET_CORNER, CORNER);
      const e = { target: TARGET_CORNER };
      locatingObject(e.target);
      TARGET_CORNER = null;
      CORNER = null;
    }
    // canvas.clearContext(canvas.contextTop);
  });

  canvas.on('after:render', () => {
    for (let i = verticalLines.length; i--; ) {
      drawVerticalLine(verticalLines[i]);
    }
    for (let i = horizontalLines.length; i--; ) {
      drawHorizontalLine(horizontalLines[i]);
    }
    verticalLines.length = horizontalLines.length = 0;
  });

  canvas.on('mouse:up', () => {
    verticalLines.length = horizontalLines.length = 0;
    canvas.renderAll();
  });
};

export const initCenteringGuidelines = ({ canvas }) => {
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  const canvasWidthCenter = canvasWidth / 2;
  const canvasHeightCenter = canvasHeight / 2;
  const canvasWidthCenterMap = {};
  const canvasHeightCenterMap = {};
  const centerLineMargin = 4;
  const centerLineColor = '#ff3333';
  const centerLineWidth = 1;
  const ctx = canvas.getSelectionContext();

  for (let i = canvasWidthCenter - centerLineMargin, len = canvasWidthCenter + centerLineMargin; i <= len; i++) {
    canvasWidthCenterMap[Math.round(i)] = true;
  }
  for (let i = canvasHeightCenter - centerLineMargin, len = canvasHeightCenter + centerLineMargin; i <= len; i++) {
    canvasHeightCenterMap[Math.round(i)] = true;
  }

  function showCenterLine(x1, y1, x2, y2) {
    const originXY = fabric.util.transformPoint(new fabric.Point(x1, y1), canvas.viewportTransform);
    const dimensions = fabric.util.transformPoint(new fabric.Point(x2, y2), canvas.viewportTransform);

    ctx.save();
    ctx.lineWidth = centerLineWidth;
    ctx.strokeStyle = centerLineColor;
    ctx.beginPath();

    ctx.moveTo(originXY.x, originXY.y);

    ctx.lineTo(dimensions.x, dimensions.y);
    ctx.stroke();
    ctx.restore();

    /* ctx.save();
      ctx.strokeStyle = centerLineColor;
      ctx.lineWidth = centerLineWidth;
      ctx.beginPath();
      ctx.moveTo(x1 * viewportTransform[0], y1 * viewportTransform[3]);
      ctx.lineTo(x2 * viewportTransform[0], y2 * viewportTransform[3]);
      ctx.stroke();
      ctx.restore(); */
  }

  function showVerticalCenterLine() {
    showCenterLine(canvasWidthCenter + 0.5, 0, canvasWidthCenter + 0.5, canvasHeight);
  }

  function showHorizontalCenterLine() {
    showCenterLine(0, canvasHeightCenter + 0.5, canvasWidth, canvasHeightCenter + 0.5);
  }

  let isInVerticalCenter;
  let isInHorizontalCenter;

  const setCenterAlignment = (e) => {
    const object = e.target;
    const objectCenter = object.getCenterPoint();
    const transform = canvas._currentTransform;

    if (!transform) return;

    isInVerticalCenter = Math.round(objectCenter.x) in canvasWidthCenterMap;
    isInHorizontalCenter = Math.round(objectCenter.y) in canvasHeightCenterMap;

    if (isInHorizontalCenter || isInVerticalCenter) {
      object.setPositionByOrigin(
        new fabric.Point(
          isInVerticalCenter ? canvasWidthCenter : objectCenter.x,
          isInHorizontalCenter ? canvasHeightCenter : objectCenter.y,
        ),
        'center',
        'center',
      );
    }
  };

  canvas.on('mouse:down', () => {
    viewportTransform = canvas.viewportTransform;
  });

  canvas.on('object:moving', (e) => {
    if (isEdgeOfPage(e.target)) return;
    setCenterAlignment(e);
  });

  canvas.on('object:scaling', () => {});

  canvas.on('before:render', () => {
    if (canvas.contextTop) {
      canvas.clearContext(canvas.contextTop);
    }
  });

  canvas.on('after:render', () => {
    if (isInVerticalCenter) {
      showVerticalCenterLine();
    }
    if (isInHorizontalCenter) {
      showHorizontalCenterLine();
    }

    distanceLines.map((e) => {
      drawDistanceLine(e.x1, e.y1, e.x2, e.y2);
      return e;
    });
    distanceLines.length = 0;
    distanceLinesConnectObj.map((e) => {
      drawDistanceLineFromObj(e.x1, e.y1, e.x2, e.y2);
      return e;
    });
    distanceLinesConnectObj.length = 0;
  });

  canvas.on('mouse:up', () => {
    // clear these values, to stop drawing guidelines once mouse is up
    isInVerticalCenter = isInHorizontalCenter = null;
    canvas.renderAll();
  });
};
